import { FullyManagedPlanContributionsShow } from '@Resources/orders/fully_managed_plan_contributions/FullyManagedPlanContributionsShow';
import { ResourceDefinition } from '@Utils/types';

export const fullyManagedPlanContributionsResource: ResourceDefinition = {
  options: { label: 'menu.fully_managed_plan_contributions' },
  show: FullyManagedPlanContributionsShow,
};
